export default __webpack_public_path__ + "static/media/7.1.633f1b7b.png";